import { addShortcutsExtension } from '../../../behaviors/shortcuts/index.js?vue3';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import initBoards from '../../../boards/index.js?vue3';

addShortcutsExtension(ShortcutsNavigation);
initBoards();
